/** Infra API del módulo Catálogo — repos, queries, CSV operations, snapshot, cache.
 * Importar desde acá para evitar require cycles. */

export {
  catalogCsvExportFilename,
  catalogCsvTemplateFilename,
  catalogCsvHeadersFor,
  catalogCsvRequiredHeadersFor,
} from './infra/csv/catalogCsvSchemas';

export {
  buildNormalizedSqlExpression,
  normalizeSearchInput,
  tokenizeSearchInput,
} from './infra/productSqlSearchNormalize';

export { buildProductCatalogHistoryCsv } from './infra/productCatalogHistoryCsv';
export { buildCatalogCsvExport, buildCatalogCsvTemplate } from './infra/csv/catalogCsvExport';
export { buildCatalogImportErrorsCsv } from './infra/csv/catalogCsvImport';
export { previewCatalogCsvImport, commitCatalogCsvImport } from './infra/csv/catalogCsvImport';

export {
  bulkUpdatePricesByCoefficient,
  bulkDeactivateProducts,
  bulkReactivateProducts,
  createProduct,
  deactivateProduct,
  getBulkPreview,
  getProductById,
  listDistinctProductBrandsLocal,
  normalizeProductCode,
  reactivateProduct,
  updateProduct,
  updateProductAvgCost,
  validateBarcode,
  validateSku,
} from './infra/productsRepo';

export {
  countSearchProducts,
  searchProducts,
  findProductByCode,
  findProductByPlu,
  buildProductDraftFromSuggestion,
  lookupProductByBarcode,
} from './infra/productCatalogSearch';

export {
  countAllCatalogProducts,
  countCatalogProducts,
  listCatalogProducts,
  listServiceProductsForPicker,
  getKitchenDestinationMap,
  mapRemoteSnapshotToSearchRow,
  type ServiceProductPickerOption,
} from './infra/catalogReadRepo';

export { patchLocalProductSkuFromServer } from './infra/productSkuServerPatch';

export {
  getProductCatalogHistory,
  getProductCatalogHistoryForExport,
} from './infra/productCatalogEventQueries';

export {
  countCategoriesLocal,
  countProductsUsingCategorySlug,
  createCategory,
  listCategories,
  listCategoriesPaged,
  setCategoryActive,
  updateCategory,
} from './infra/categoriesRepo';

export {
  countSuppliersLocal,
  createSupplier,
  getSupplierByIdLocal,
  listActiveSuppliersLocal,
  listSuppliersLocalPaged,
  setSupplierActive,
  updateSupplier,
} from './infra/suppliersRepo';

export {
  countBrandsLocal,
  createBrand,
  listActiveBrandsLocal,
  listBrandsLocalPaged,
  setBrandActive,
  updateBrand,
} from './infra/brandsRepo';

export {
  syncCatalogSnapshotFromRemote,
  syncCatalogSnapshotAfterLocalWrite,
  resetCatalogSnapshotSyncRuntimeState,
  getActiveCatalogSnapshotSync,
  type CatalogSnapshotSyncResult,
} from './infra/catalogSnapshotSync';
export { preflightCatalogSnapshotForRead, resetCatalogReadPreflightState } from './infra/catalogReadPreflight';
export {
  markCatalogHydrated,
  wasCatalogHydratedRecently,
  resetCatalogHydrationState,
} from './infra/catalogHydrationState';

export { clearCatalogRamSnapshotCache, getCatalogRamSnapshotCache } from './infra/catalogRamSnapshotCache';
// #862: exponer patch functions via public-api para que stock no importe directo de catalog/infra
export { patchWebCatalogStockInCache, patchWebCatalogStocksBatchInCache, patchWebCatalogStockTransferInCache, patchWebCatalogPromotionInCache, upsertWebCatalogPromotionInCache, upsertWebCatalogPriceListInCache } from './infra/catalogRamSnapshotCache';
export type {
  WebCatalogPriceListRow,
  WebCatalogPromotionRow,
  WebCatalogPromotionTargetRow,
} from './infra/catalogRamSnapshotCache';

export { listVariantsForProduct, listInactiveVariantsForProduct, createVariant, updateVariant, deactivateVariant, reactivateVariant } from './infra/productVariantsRepo';
export type { ProductVariantMutationInput } from './infra/productVariantsRepo';

export {
  fetchMenuOptionsForProducts,
  listOrgOptionGroups,
  upsertOptionGroup,
  assignOptionGroupsToProduct,
  setProductMenuAvailable,
  peekCachedMenuOptions,
  readPersistedMenuOptions,
  invalidateMenuOptionsMemoryCache,
} from './infra/menuModifiersRepo';

export {
  fetchProductCombos,
  upsertProductCombo,
} from './infra/productCombosRepo';

export { getComboParentProductIds } from './infra/comboParentProductIds';

export { catalogSnapshotVerboseLog } from './infra/catalogSnapshotVerbose';

export {
  mergeRemoteSnapshotStocks,
  applyRemoteCatalogSnapshotStockWrites,
} from './infra/catalogSnapshotStockApply';
export { aggregateRemoteStocksByProduct } from './infra/productCatalogRemoteSnapshot';

export { ensureLocalProductFromWebCache } from './infra/ensureLocalProductFromWebCache';
export { pickProductImage, isProductImageValidationError } from './infra/pickProductImage';
export type { PickedProductImage } from './infra/pickProductImage';
